import { Action } from '../../../redux/redux.types';
import { MODAL_MESSAGE_NAMES } from './modal-message.actions';
import { ModalMessageState } from './modal-message.types';

const defaultState: ModalMessageState = {
  shown: false,
};

export const modalMessage = (
  state: ModalMessageState = defaultState,
  { type }: Action,
) => {
  switch (type) {
    case MODAL_MESSAGE_NAMES.SHOWN:
      return {
        shown: true,
      };

    case MODAL_MESSAGE_NAMES.CLOSED:
      return {
        shown: false,
      };

    default: {
      return state;
    }
  }
};
